import React from "react";

const transform = ({ price, support_levels }) => {
  return [
    ...support_levels,
    {
      level: price,
      weight: 99999,
    },
  ]
    .sort((a, b) => (a.level > b.level ? -1 : 1))
    .map((e) => {
      if (e.weight === 99999) {
        return {
          color: "bg-transparent",
          textColor: "text-white",
          label: "$" + e.level.toFixed(2),
        };
      }
      var pallete = e.level > price ? "red" : "green";
      var adjustedWeight = Math.round(e.weight * 100 * 1);
      if (adjustedWeight > 9) {
        adjustedWeight = 9;
      }
      return {
        color: `bg-${pallete}-${adjustedWeight * 100}`,
        label: "$" + e.level.toString(),
        textColor: "text-black",
      };
    });
};

export default ({ data: { price, support_levels } }) => {
  return (
    <div className="flex flex-col mt-8 md:mt-6 mr-0 md:mr-1">
      <div className="title mb-1 text-left">Support/Resistance Levels</div>
      {transform({ price, support_levels }).map((lvl) => (
        <div className={`text-sm mt-0.5 py-0.5 ${lvl.textColor} ${lvl.color}`}>
          {lvl.label}
        </div>
      ))}
    </div>
  );
};
